// extracted by mini-css-extract-plugin
export default {"flex":"TagMasterTable_flex__VOKNS","btn":"TagMasterTable_btn__widj7","btn1":"TagMasterTable_btn1__dhXEm","main":"TagMasterTable_main__nMrWO","center":"TagMasterTable_center__92JBb"};